// ─── Constants ────────────────────────────────────────────
export const DAYS   = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const MONTHS = ["January","February","March","April","May","June", "July","August","September","October","November","December"];

export const ADMIN_PASSWORD = "admin123"; // TODO: replace with backend auth
export const API = "https://iy-sp.org/api";

export const DEFAULT_CLASS = {
  title: "", dayOfWeek: 0, time: "09:00", duration: 60,
  teacher: "", venue: "venue_001", price: 20,
};

export const EMPTY_PRICING = { perSession: 40, fullDay: 70, fullWorkshop: 200 };

// ─── Helpers ──────────────────────────────────────────────
export function formatTime(t) {
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "pm" : "am";
  const h12 = h % 12 || 12;
  return m === 0 ? `${h12}${ap}` : `${h12}:${String(m).padStart(2,"0")}${ap}`;
}

export function toLocalDateStr(date) {
  return [date.getFullYear(),
    String(date.getMonth()+1).padStart(2,"0"),
    String(date.getDate()).padStart(2,"0")].join("-");
}

export function isEventPast(dateStr, time, duration) {
  const end = new Date(`${dateStr}T${time}`);
  end.setMinutes(end.getMinutes() + duration);
  return end < new Date();
}

export function isWorkshopPast(workshop) {
  const lastDay = workshop.days[workshop.days.length - 1];
  if (!lastDay) return false;
  const lastSession = lastDay.sessions[lastDay.sessions.length - 1];
  if (!lastSession) return new Date(`${lastDay.date}T23:59`) < new Date();
  return isEventPast(lastDay.date, lastSession.time, lastSession.duration);
}

export function getDaysInMonth(y, m) { return new Date(y, m+1, 0).getDate(); }
export function getFirstDay(y, m)    { return new Date(y, m, 1).getDay(); }
export function isSameDay(a, b) {
  return a.getFullYear()===b.getFullYear() &&
         a.getMonth()===b.getMonth() &&
         a.getDate()===b.getDate();
}
export function getWeekDates(date) {
  const start = new Date(date);
  start.setDate(date.getDate() - date.getDay());
  return Array.from({length:7},(_,i)=>{ const d=new Date(start); d.setDate(start.getDate()+i); return d; });
}
export function parseLocalDate(str) { return new Date(str + "T12:00:00"); }
export function workshopDateRange(w) { return w.days.map(d => d.date).sort(); }
export function workshopsForDate(dateStr, workshops) {
  return workshops.filter(w => w.days.some(d => d.date === dateStr));
}